(function () {
  function initHeroVideo() {
    var video = document.querySelector('.hero-video');
    if (!video) return;

    var source = video.querySelector('source[data-src]');
    if (!source) return;

    function playVideo() {
      video.play().catch(function () {
        // Autoplay bloqueado pelo navegador (ex: economia de dados no mobile).
        // O poster estático já definido no <video> permanece visível.
      });
    }

    function onError() {
      // Falha de rede/carregamento do vídeo: mantém apenas o poster estático
      // em vez de deixar um elemento quebrado na tela.
      video.removeEventListener('canplay', playVideo);
      video.style.display = 'none';
    }

    function loadVideo() {
      video.addEventListener('canplay', playVideo, { once: true });
      video.addEventListener('error', onError, { once: true });
      source.src = source.getAttribute('data-src');
      video.load();
    }

    // Carrega o vídeo só depois que a página termina de carregar, e de
    // preferência em um momento ocioso — assim ele nunca disputa banda com
    // CSS/JS/imagens críticas nem atrasa o primeiro paint em conexões lentas.
    if ('requestIdleCallback' in window) {
      requestIdleCallback(loadVideo, { timeout: 2000 });
    } else {
      setTimeout(loadVideo, 300);
    }
  }

  if (document.readyState === 'complete') {
    initHeroVideo();
  } else {
    window.addEventListener('load', initHeroVideo);
  }
})();
